<div fxLayout fxLayoutAlign="center center" style="border-radius: 50%; height: 50px; color: white"
     [ngClass]="badgeClass">
    {{text}}
</div>
